/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiCirclePauseIcon16Light } from './MediaUiCirclePauseIcon16Light';
import { MediaUiCirclePauseIcon16Regular } from './MediaUiCirclePauseIcon16Regular';
import { MediaUiCirclePauseIcon16Solid } from './MediaUiCirclePauseIcon16Solid';
import { MediaUiCirclePauseIcon20Light } from './MediaUiCirclePauseIcon20Light';
import { MediaUiCirclePauseIcon20Regular } from './MediaUiCirclePauseIcon20Regular';
import { MediaUiCirclePauseIcon20Solid } from './MediaUiCirclePauseIcon20Solid';
import { MediaUiCirclePauseIcon24Regular } from './MediaUiCirclePauseIcon24Regular';
import { MediaUiCirclePauseIcon24Solid } from './MediaUiCirclePauseIcon24Solid';
import { MediaUiCirclePauseIcon32Regular } from './MediaUiCirclePauseIcon32Regular';
import { MediaUiCirclePauseIcon64Regular } from './MediaUiCirclePauseIcon64Regular';
var sizes = {
    16: {
        light: MediaUiCirclePauseIcon16Light,
        regular: MediaUiCirclePauseIcon16Regular,
        solid: MediaUiCirclePauseIcon16Solid,
    },
    20: {
        light: MediaUiCirclePauseIcon20Light,
        regular: MediaUiCirclePauseIcon20Regular,
        solid: MediaUiCirclePauseIcon20Solid,
    },
    24: {
        regular: MediaUiCirclePauseIcon24Regular,
        solid: MediaUiCirclePauseIcon24Solid,
    },
    32: {
        regular: MediaUiCirclePauseIcon32Regular,
    },
    64: {
        regular: MediaUiCirclePauseIcon64Regular,
    },
};
export var MediaUiCirclePauseIcon = forwardRef('MediaUiCirclePauseIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
